import SignalMappingComponent from "@/components/signalMapping/signal_mapping";
import {alarm, flashBackGround} from "@/components/signalMapping/scripts/alarm";

/**
 * 生データを元にパトランプの点灯表示を制御
 * @param self
 * @param signallampSensorData
 */
export function changeSignallMapFlash(
  self: SignalMappingComponent,
  signallampSensorData: any,
) {
  if (signallampSensorData && self.lampColors.length > 0) {
    for (let i = 0; i < 4; i++) {
      const status = signallampSensorData[`lamp${i + 1}_state`];
      self.lampColors[i].flush = false;
      if (status > 0) {
        self.lampColors[i].flush = true;
        alarm(self, signallampSensorData);
      }
      flashBackGround(self, signallampSensorData);
    }
  }
}
